export default "__VITE_ASSET__DiGseZgj__"